// extracted by mini-css-extract-plugin
export var messageSideLeft = "_k5-1";
export var messageSideRight = "_k5-2";
export var subscribeToBackInStockBubbleContainer = "_k5-0";